// extracted by mini-css-extract-plugin
export default {"container":"FromToPicker_container__9c-Fu","text":"FromToPicker_text__UsZ8I"};